<!-- 智慧停车用户实名认证图片上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "cmd": "reportAuthUserAuthPic",
                "phone": "18054103169",
                "userId": 128,
                "authId": 123,
                "credUrl": "http://ake-parking-test.oss-cn-shenzhen.aliyuncs.com/clound-oss/ydt-user-weixin/carlicense/2019/08/05/573579bc-e6c5-4f6d-a0fa-fae369ecb52d.jpg",
                "credBackUrl": "http://ake-parking-test.oss-cn-shenzhen.aliyuncs.com/clound-oss/ydt-user-weixin/carlicense/2019/08/05/573579bc-e6c5-4f6d-a0fa-fae369ecb52d.jpg",
                "idCardFrontUrl": "http://ake-parking-test.oss-cn-shenzhen.aliyuncs.com/clound-oss/ydt-user-weixin/carlicense/2019/08/05/573579bc-e6c5-4f6d-a0fa-fae369ecb52d.jpg",
                "idCardBackUrl": "http://ake-parking-test.oss-cn-shenzhen.aliyuncs.com/clound-oss/ydt-user-weixin/carlicense/2019/08/05/573579bc-e6c5-4f6d-a0fa-fae369ecb52d.jpg",
                "idCardHandUrl": "http://ake-parking-test.oss-cn-shenzhen.aliyuncs.com/clound-oss/ydt-user-weixin/carlicense/2019/08/05/573579bc-e6c5-4f6d-a0fa-fae369ecb52d.jpg",
                "lockKey": "2420e3efbf6124c7185365b79c75c0f5be61a049"
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报智慧停车用户实名认证图片到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportCertificationUser",
                precondition: "无",
                fitSystem: "VEMS传统停车场,云停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'phone', info2: '是', info3: 'String', info4: '用户电话号码' },
                        { info1: 'userId', info2: '是', info3: 'Long', info4: '智慧停车用户id' },
                        { info1: 'authId', info2: '是', info3: 'String', info4: '认证记录id' },
                        { info1: 'credUrl', info2: '是', info3: 'String', info4: '行驶证主页图片（url）' },
                        { info1: 'credBackUrl', info2: '是', info3: 'String', info4: '行驶证副页图片（url）' },
                        { info1: 'idCardFrontUrl', info2: '是', info3: 'String', info4: '身份证正面图片（url）' },
                        { info1: 'idCardBackUrl', info2: '是', info3: 'String', info4: '身份证背面图片（url）' },
                        { info1: 'idCardHandUrl', info2: '是', info3: 'String', info4: '用户手持身份证正面图片（url）' },
                        { info1: 'lockKey', info2: '是', info3: 'String', info4: '数据唯一标识' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ydtUser/reportCertificationUser.vue